var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "./extended-model-schema.class", "./data-schema.class"], function (require, exports, extended_model_schema_class_1, data_schema_class_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ModelSchema = /** @class */ (function (_super) {
        __extends(ModelSchema, _super);
        function ModelSchema(attributes) {
            if (attributes === void 0) { attributes = {}; }
            var _this = _super.call(this) || this;
            _this.attributes = attributes;
            _this._versionNumbers = [];
            _this._attributes = {};
            _this._deletions = {};
            _this._extensions = {};
            _this._attributes[_this.version] = attributes;
            _this._versionNumbers.push(_this.version);
            return _this;
        }
        Object.defineProperty(ModelSchema.prototype, "edgeVersion", {
            get: function () {
                return this._versionNumbers[this._versionNumbers.length - 1];
            },
            enumerable: true,
            configurable: true
        });
        ModelSchema.prototype._getExclusiveFields = function (version) {
            if (version === void 0) { version = null; }
            if (version === null) {
                version = this.edgeVersion;
            }
            var attributes = {};
            var versionIndex = this._versionNumbers.indexOf(version);
            if (versionIndex === -1) {
                return null;
            }
            var versions = this._versionNumbers.slice(0, versionIndex + 1);
            for (var _i = 0, versions_1 = versions; _i < versions_1.length; _i++) {
                var v = versions_1[_i];
                if (this._deletions[v]) {
                    // suppressions
                    for (var _a = 0, _b = this._deletions[v]; _a < _b.length; _a++) {
                        var deletedKey = _b[_a];
                        for (var vid in attributes) {
                            if (attributes.hasOwnProperty(vid) && attributes[vid][deletedKey] !== undefined) {
                                delete attributes[vid][deletedKey];
                            }
                        }
                    }
                }
                var fields = this._copyObject(this._attributes[v]);
                attributes[v] = fields;
            }
            return attributes;
        };
        ModelSchema.prototype._copyObject = function (object) {
            var copy = {};
            for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
                var key = _a[_i];
                copy[key] = object[key];
            }
            return copy;
        };
        ModelSchema.prototype._getExclusiveFieldsAtVersion = function (version) {
            var attributes = {};
            var versionIndex = this._versionNumbers.indexOf(version);
            if (versionIndex === -1) {
                return null;
            }
            for (var key in this._attributes[version]) {
                if (this._attributes[version].hasOwnProperty(key)) {
                    attributes[key] = this._attributes[version][key];
                }
            }
            return attributes;
        };
        ModelSchema.prototype._getFieldsAtVersion = function (version) {
            var versionIndex = this._versionNumbers.indexOf(version);
            if (versionIndex === -1) {
                return null;
            }
            var versions = this._versionNumbers.slice(0, versionIndex + 1);
            var attributes = {};
            for (var i = 0; i < versions.length; i++) {
                var versionNumber = versions[i];
                var attributesInVersion = this._attributes[versionNumber];
                //console.log("att in", attributesInVersion, this._attributes);
                if (this._deletions[versionNumber]) {
                    for (var _i = 0, _a = this._deletions[versionNumber]; _i < _a.length; _i++) {
                        var key = _a[_i];
                        if (attributes[key]) {
                            delete attributes[key];
                        }
                    }
                }
                for (var key in attributesInVersion) {
                    if (attributesInVersion.hasOwnProperty(key)) {
                        attributes[key] = attributesInVersion[key];
                    }
                }
            }
            //console.log("vers", version, versions, attributes);
            //console.log(version, versions, attributes);
            return attributes;
        };
        ModelSchema.prototype._getFieldDefaultValue = function (field) {
            return field.defaultValue;
        };
        ModelSchema.prototype.filterModel = function (attributes, version) {
            if (version === void 0) { version = null; }
            var updated = {};
            if (!version) {
                version = this.edgeVersion;
            }
            //console.log("filter", attributes, version);
            var fields = this._getFieldsAtVersion(version);
            for (var key in fields) {
                if (fields.hasOwnProperty(key)) {
                    if (attributes[key] === undefined) {
                        // 1- le champ n'existe pas dans les attributes. Création de sa valeur par défaut
                        updated[key] = this._getFieldDefaultValue(fields[key]);
                    }
                    else if (!fields[key].getStackValidity(attributes[key])) {
                        // 2- le champ existe, mais avec une valeur incorrecte. Remplacement par sa valeur par défaut
                        updated[key] = this._getFieldDefaultValue(fields[key]);
                    }
                    else {
                        // 3- Utilisation de la valeur actuelle
                        updated[key] = attributes[key];
                    }
                }
            }
            return updated;
        };
        ModelSchema.prototype.validateModel = function (attributes, version) {
            if (version === void 0) { version = null; }
            if (version === null) {
                version = this.edgeVersion;
            }
            var completeAttributes = this._getFieldsAtVersion(version);
            //console.log("ca", version, completeAttributes);
            for (var key in attributes) {
                if (attributes.hasOwnProperty(key)) {
                    if (!completeAttributes[key]) {
                        return false;
                    }
                }
            }
            for (var key in completeAttributes) {
                if (completeAttributes.hasOwnProperty(key)) {
                    // TODO: verifier si on peut tester d'une meilleure manière la non-définition de la valeur
                    if (attributes[key] === undefined) {
                        return false;
                    }
                    if (attributes[key] && !completeAttributes[key].getStackValidity(attributes[key])) {
                        return false;
                    }
                }
            }
            return true;
        };
        ModelSchema.prototype.blindValidate = function (attributes) {
            for (var _i = 0, _a = this._versionNumbers; _i < _a.length; _i++) {
                var version = _a[_i];
                var updated = this.filterModel(attributes, version);
                if (this.validateModel(attributes, version)) {
                    console.log("Validated at", version, attributes);
                    return true;
                }
            }
            return false;
        };
        ModelSchema.prototype.generateModel = function (version, defaults) {
            if (version === void 0) { version = null; }
            if (defaults === void 0) { defaults = null; }
            var generatedModel = {};
            if (version === null) {
                version = this.edgeVersion;
            }
            var completeAttributes = this._getFieldsAtVersion(version);
            // vérification des defaults
            if (defaults) {
                for (var _i = 0, _a = Object.keys(defaults); _i < _a.length; _i++) {
                    var key = _a[_i];
                    if (completeAttributes[key] === undefined) {
                        console.log("Generate model: incorrect field in default - " + key);
                    }
                }
            }
            for (var key in completeAttributes) {
                if (completeAttributes.hasOwnProperty(key)) {
                    if (defaults && defaults[key] !== undefined) {
                        if (!completeAttributes[key].getStackValidity(defaults[key])) {
                            console.log("Generate model: default value do not match the schema - " + key);
                            generatedModel[key] = completeAttributes[key].defaultValue;
                        }
                        else {
                            generatedModel[key] = defaults[key];
                        }
                    }
                    else {
                        generatedModel[key] = completeAttributes[key].defaultValue;
                    }
                }
            }
            return generatedModel;
        };
        ModelSchema.prototype.addVersion = function (versionNumber, attributes) {
            if (this._versionNumbers.indexOf(versionNumber) !== -1) {
                console.log("Model version overriding attempt. Addition is ignored.");
                return;
            }
            this._versionNumbers.push(versionNumber);
            if (attributes.additions) {
                this._attributes[versionNumber] = attributes.additions;
            }
            if (attributes.deletions) {
                this._deletions[versionNumber] = attributes.deletions;
            }
            var extension = new extended_model_schema_class_1.ExtendedModelSchema(this, versionNumber);
            this._extensions[versionNumber] = extension;
            return extension;
        };
        ModelSchema.prototype._getVersionPrefix = function (version) {
            return "v" + version + "_";
        };
        ModelSchema.prototype.getFromVersionedAttributes = function (versioned, targetVersion, usePrefix) {
            if (targetVersion === void 0) { targetVersion = null; }
            if (usePrefix === void 0) { usePrefix = true; }
            if (targetVersion === null) {
                targetVersion = this.edgeVersion;
            }
            var fields = this._getExclusiveFields(targetVersion);
            var retAttributes = {};
            var vAttributes = versioned;
            for (var vnum in fields) {
                if (fields.hasOwnProperty(vnum)) {
                    var versionFields = fields[vnum];
                    for (var key in vAttributes) {
                        if (vAttributes.hasOwnProperty(key)) {
                            if (vAttributes[key] !== undefined) {
                                var newKey = void 0;
                                if (usePrefix && key.indexOf("v" + vnum + "_") === 0) {
                                    newKey = key.replace("v" + vnum + "_", "");
                                }
                                else {
                                    newKey = key;
                                }
                                if (versionFields[newKey] !== undefined) {
                                    retAttributes[newKey] = vAttributes[key];
                                }
                            }
                        }
                    }
                }
            }
            return retAttributes;
        };
        ModelSchema.prototype.getVersionedAttributes = function (attributes, version, usePrefix) {
            if (version === void 0) { version = null; }
            if (usePrefix === void 0) { usePrefix = true; }
            if (version === null) {
                version = this.edgeVersion;
            }
            var retAttributes = {};
            var versionIndex = this._versionNumbers.indexOf(version);
            var subVersions = this._versionNumbers.slice(0, versionIndex + 1);
            for (var _i = 0, subVersions_1 = subVersions; _i < subVersions_1.length; _i++) {
                var vnum = subVersions_1[_i];
                var exclusives = this._getExclusiveFieldsAtVersion(vnum);
                for (var key in exclusives) {
                    if (exclusives.hasOwnProperty(key)) {
                        if (attributes[key] !== undefined) {
                            var newKey = usePrefix ? this._getVersionPrefix(vnum) + key : key;
                            retAttributes[newKey] = attributes[key];
                        }
                    }
                }
            }
            return retAttributes;
        };
        return ModelSchema;
    }(data_schema_class_1.DataSchema));
    exports.ModelSchema = ModelSchema;
});
